import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import Button from '@mui/material/Button';
import TextInput from '../../inputControls/TextInput';
import validate from '../../../common/loginValidation';
import * as Constant from '../../../constants/actionTypes';
import { labelName } from '../../UtilsWeb';
import styles from './styles';

const ProviderLoginForm = ({ pristine, handleSubmit, submitting, error, classes }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div key={0}>{!!error && <p className={classes.error}>{labelName(error)}</p>}</div>
      <Field
        name={Constant.MEMBER_ID}
        component={TextInput}
        label={labelName(Constant.LABEL_MEMBER_ID)}
        fullWidth
        className={classes.marginSet}
        autoComplete="off"
      />
      <Field
        name={Constant.ACCESS_CODE}
        component={TextInput}
        label={labelName(Constant.LABEL_SHARED_OTP)}
        type={Constant.TEXT}
        className={classes.marginSet}
        fullWidth
        autoComplete="off"
      />
      <Button
        variant="contained"
        type="submit"
        color="primary"
        disabled={pristine || submitting}
        fullWidth
        className={classes.marginSet}
      >
        {labelName(Constant.LABEL_SUBMIT)}
      </Button>
    </form>
  );
};

ProviderLoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

ProviderLoginForm.defaultProps = {
  error: Constant.EMPTY_VALUE,
};

export default reduxForm({
  form: Constant.PROVIDER_SIGN_IN,
  validate,
})(withStyles(styles)(ProviderLoginForm));
